import { render, staticRenderFns } from "./collectionPlan.vue?vue&type=template&id=e5181494&scoped=true"
import script from "./collectionPlan.vue?vue&type=script&lang=js"
export * from "./collectionPlan.vue?vue&type=script&lang=js"
import style0 from "./collectionPlan.vue?vue&type=style&index=0&id=e5181494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5181494",
  null
  
)

export default component.exports